import React from 'react'
import { useMevIntegration } from '../../../routes/ConfigPage/ThirdPartyConfigPage/useMevIntegration';
import { Alert, Button, Form, Input, Skeleton, Tooltip, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import Flex from '../../../components/Flex';
import useMe from '../../../hooks/useMe';
import { ClearScrapingButton } from './PjnNumberInput';

export function MevCausaInput({ getFieldDecorator, isFieldTouched, getFieldError, expedient, editing }) {

    const { mev: mevData, loading: loadingMev } = useMevIntegration();
    const { mev_user, mev_password } = mevData || { mev_user: null, mev_password: null }
    const { user } = useMe()
    const hasUser = mev_user && mev_password
    const noUsageLeft = !(mevData && mevData.usage && mevData.usage.used < mevData.usage.total)
    const hasMev = (user && user.studio && !!user.studio.mev_scraping)

    const alreadyVinculted = editing && expedient && expedient.mev_causa && expedient.mev_causa.length > 0;

    if (loadingMev) {
        return (
            <Form.Item>
                <Skeleton className="responsive-input" paragraph={{ rows: 1 }} active />
            </Form.Item>
        )
    }

    if (!hasMev) return null

    const mevCausaError = isFieldTouched("mev_causa") && getFieldError("mev_causa");

    return (
        <Flex flexDirection="column">

            <Form.Item
                labelCol={{ span: 24 }}
                key="mev_causa"
                label={<div><Typography.Text>
                    Causa MEV{" "}
                    <Tooltip title="Solo numero de causa MEV sin prefijo ni sufijo">
                        <InfoCircleOutlined />
                    </Tooltip>
                </Typography.Text>
                    <br />
                </div>
                }
                help={
                    mevCausaError ? "Ingrese solo números sin prefijo ni sufijo" :
                        !hasUser ? "No posee credenciales MEV" :
                            noUsageLeft ? "Limite MEV de su plan alcanzado" :
                                `Vinculaciones MEV restantes: ${mevData ? mevData.usage.left : "..."}`
                }
                validateStatus={mevCausaError ? "error" : "success"}
            >

                {
                    getFieldDecorator("mev_causa", {
                        initialValue: editing
                            ? expedient.mev_causa
                                ? expedient.mev_causa
                                : null
                            : null,
                        rules: [
                            {
                                pattern: new RegExp(/^[0-9]+$/),
                                message: "Por favor, ingrese solo números."
                            }
                        ]
                    })(
                        <MevInput disabled={!hasUser || (noUsageLeft && !alreadyVinculted)} />
                    )}
            </Form.Item >

            {!hasUser ?
                <a href="/settings#integraciones" style={{ alignSelf: "end" }}>
                    <Button type="primary">Configurar MEV</Button>
                </a> :
                noUsageLeft ?
                    <a href="https://metajuridico.com/planes_actualizacion.html" target="_blank" style={{ alignSelf: "end" }}>
                        <Button type="primary">Ampliar Plan</Button>
                    </a> : null}
        </Flex>
    )
}

const MevInput = ({ value, onChange, disabled }) => {
    return (
        <Flex flexDirection="row" gap="0.5ch" flexGrow={1}>
            <Flex flexDirection="column" gap="0.5ch" alignItems="left" flexGrow={1}>
                <label style={{ fontSize: "10px" }}>Numero</label>
                <Input className="responsive-input" onChange={onChange} value={value} disabled={disabled} />
            </Flex>
            <Flex flexDirection="column" gap="0.5ch" alignItems="center">
                <label style={{ fontSize: "10px" }}>&nbsp;</label>
                <ClearScrapingButton onClick={() => onChange && onChange("")} disabled={disabled} tooltipText="Eliminar causa MEV" />
            </Flex>
        </Flex>
    )
}